module.exports = __webpack_public_path__ + "img/pleven.66162e13.jpg";